import React from 'react'
import CustomizedDialogs from '../../../common/CustomizedDialogs'
import { Box, CircularProgress, Typography } from '@mui/material'

import HourglassTopIcon from '@mui/icons-material/HourglassTop';
const UnutilizedPytInfo = (props) => {
    const { open = false, data = {} } = props
    return (
        <CustomizedDialogs
            open={open}
            width={'420px'}
            height={'auto'}
            onClose={() => {

            }}
            padding={'0px'}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 4,
                    gap: 2,
                    textAlign: "center",
                }}
            >
                <HourglassTopIcon
                    sx={{
                        fontSize: 48,
                        color: '#0086FF',
                        animation: "spin 2s linear infinite",
                    }}
                />
                <Typography variant="h6" fontWeight="600">
                    Processing Refund
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    We’re processing your refund for <b>Order ID {data}</b>. <br />
                    This may take a few moments…
                </Typography>

            </Box>

            {/* Animation Keyframes */}
            <style>
                {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
            </style>
        </CustomizedDialogs>
    )
}

export default UnutilizedPytInfo